import React, { useState, useEffect } from 'react'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import { useSelector } from 'react-redux'
import { useAppDispatch, RootState, AppDispatch } from '../../redux/store'
import { Breadcrumbs, Grid, Link, Paper, Typography } from '@mui/material'
import { SelectChangeEvent } from '@mui/material/Select'
import { useNavigate, useParams } from 'react-router-dom'
import UseAlert from '../../components/common/useAlerte'
import { addCoutSupplementaire } from '../../redux/CoutSupplementaire/coutSupplementaireAction'
import SelectMission from '../../components/common/SelectMission'
import { NumberTextField } from '../../components/common/NumberInput'
import { t } from 'i18next'
import { selectError as selectCoutSuppError } from '../../redux/CoutSupplementaire/coutSupplementaireSelector'
import { clearCoutSupplementaireError } from '../../redux/CoutSupplementaire/coutSupplementaireSlice'

interface CoutSupplementaireCreatProps {
  onClose: () => void
  ActionId: string
  onSuccess?: () => void
}

const CoutSupplementaireCreate: React.FC<CoutSupplementaireCreatProps> = ({
  onClose,
  ActionId,
  onSuccess,
}) => {
  const [coutSupplementaire, setCoutSupplementaire] = useState({
    Montant: 0,
    ActionId: ActionId,
  })

  const dispatch: AppDispatch = useAppDispatch()
  const apiError = useSelector(selectCoutSuppError)

  const [alert, setAlert] = useState({
    open: false,
    message: '',
    status: 0,
  })
  const navigate = useNavigate()

  const handleInputChange = (event: any) => {
    const { name, value } = event.target
    setCoutSupplementaire((prevCoutSupplementaire) => ({
      ...prevCoutSupplementaire,
      [name]: value,
    }))
  }
  const handleCloseAlert = () => {
    setAlert({
      ...alert,
      open: false,
    })
    if (alert.status >= 400) {
      dispatch(clearCoutSupplementaireError())
    }
  }

  useEffect(() => {
    if (apiError) {
      setAlert({
        open: true,
        message: apiError,
        status: 400,
      })
    }
  }, [apiError])

  const handleAddCoutSupplementaire = async () => {
    if (coutSupplementaire.Montant && ActionId) {
      try {
        const newCoutSupp = {
          Montant: coutSupplementaire.Montant,
          ActionId: ActionId,
        }
        await dispatch(addCoutSupplementaire(newCoutSupp)).unwrap()
        setAlert({
          open: true,
          message: t('alerts.coutSuppAdd.success'),
          status: 200,
        })
        setCoutSupplementaire({
          Montant: 0,
          ActionId: '',
        })
        if (onSuccess) {
          onSuccess()
        }
        onClose()
      } catch (error) {
        console.error('Failed to add supplementary cost:', error)
      }
    } else {
      setAlert({
        open: true,
        message: t('alerts.coutSuppAdd.emptyFields'),
        status: 400,
      })
    }
  }

  return (
    <>
      <Paper className="paper-flex-column">
        <div
          style={{
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '24px',
          }}
        >
          <Typography variant="h6" component="h6" color="">
            {t('popups.addAdditionalCost.title')}
          </Typography>
        </div>

        <UseAlert
          open={alert.open}
          message={alert.message}
          status={alert.status}
          onClose={handleCloseAlert}
        />
        <form style={{ width: '100%', marginTop: '20px' }}>
          <Stack spacing={2}>
            <Stack direction="row" spacing={2}></Stack>

            <NumberTextField
              currency
              label={t('popups.addAdditionalCost.fields.Montant')}
              name="Montant"
              value={coutSupplementaire.Montant}
              onChange={(v) =>
                setCoutSupplementaire((prev) => ({ ...prev, Montant: v ?? 0 }))
              }
              required
              fullWidth
              className="textF-style"
            />

            <div className="flex-end">
              <Button
                className="buttonAdd"
                variant="contained"
                onClick={handleAddCoutSupplementaire}
              >
                {t('buttons.add')}
              </Button>
              <Button onClick={onClose} variant="outlined">
                {t('buttons.cancel')}
              </Button>
            </div>
          </Stack>
        </form>
      </Paper>
    </>
  )
}

export default CoutSupplementaireCreate
